import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "renameTest.title",
    },
    titleHomework: {
        id: "renameHomework.title",
    },
    label: {
        id: "newTest.label",
    },
    labelHomework: {
        id: "homework.title",
    },
    description: {
        id: "newTest.description",
    },
    rename: {
        id: "general.rename",
    },
    cancel: {
        id: "general.cancel",
    },
});

export default messages;
